const DENY_LABELS = {
    // fr: 'Tout refuser' — tarteaucitron default is already correct
    en: 'Reject all',
    de: 'Alle ablehnen',
    es: 'Rechazar todo',
    it: 'Rifiuta tutti',
};

const CONSENT_MESSAGES = {
    fr: 'Nous utilisons des cookies pour vous afficher les meilleurs spots et améliorer la plateforme. Vos données restent en Europe.',
    en: 'We use cookies to show you the best spots and improve the platform. Your data stays in the EU.',
    de: 'Wir nutzen Cookies, um Ihnen die besten Fundorte anzuzeigen und die Plattform zu verbessern. Ihre Daten bleiben in Europa.',
    es: 'Usamos cookies para mostrarte los mejores puntos de recolección y mejorar la plataforma. Tus datos permanecen en Europa.',
    it: 'Usiamo i cookie per mostrarti i migliori punti di raccolta e migliorare l\'app. I tuoi dati restano in Europa.',
};

const CONSENT_CSS = `
#tarteaucitronRoot {
    pointer-events: none !important;
}
#tarteaucitronRoot > * {
    pointer-events: auto !important;
}
#tarteaucitronRoot #tarteaucitronAlertBig {
    flex-wrap: wrap !important;
    align-items: center !important;
    justify-content: center !important;
    background: #f2cfae !important;
    border-top: 1px solid #dbb48a !important;
    box-shadow: 0 -8px 24px rgba(0, 0, 0, 0.18) !important;
    color: #404923 !important;
    padding: 12px 24px !important;
    box-sizing: border-box !important;
}
#tarteaucitronAlertBig span#tarteaucitronDisclaimerAlert {
    flex: 0 0 100% !important;
    display: block !important;
    text-align: center !important;
    margin-bottom: 8px !important;
    order: 0 !important;
    color: #404923 !important;
}
@media (min-width: 769px) {
    #tarteaucitronRoot #tarteaucitronAlertBig {
        flex-wrap: nowrap !important;
        gap: 16px !important;
    }
    #tarteaucitronAlertBig span#tarteaucitronDisclaimerAlert {
        flex: 1 1 auto !important;
        text-align: left !important;
        margin-bottom: 0 !important;
        max-width: 640px !important;
        font-size: 14px !important;
        line-height: 1.45 !important;
    }
}
@media (max-width: 768px) {
    #tarteaucitronRoot #tarteaucitronAlertBig {
        font-size: 13px !important;
    }
    #tarteaucitronAlertBig span#tarteaucitronDisclaimerAlert {
        font-size: 13px !important;
    }
    #tarteaucitronAlertBig #tarteaucitronPrivacyUrl,
    #tarteaucitronAlertBig #tarteaucitronPrivacyUrlDialog {
        display: none !important;
    }
    #tarteaucitronAlertBig #tarteaucitronAllDenied2,
    #tarteaucitronAlertBig #tarteaucitronPersonalize2 {
        flex: 1 1 auto !important;
    }
    #tarteaucitronAlertBig #tarteaucitronCloseAlert {
        flex: 0 0 100% !important;
        text-align: center !important;
    }
}
#tarteaucitronAllDenied2 {
    order: 1 !important;
}
#tarteaucitronPersonalize2 {
    order: 2 !important;
}
#tarteaucitronCloseAlert {
    order: 3 !important;
}
#tarteaucitronPrivacyUrl, #tarteaucitronPrivacyUrlDialog {
    order: 4 !important;
    color: #404923 !important;
}
#tarteaucitronAlertSmall,
#tarteaucitronIcon {
    display: none !important;
}
#tarteaucitronPersonalize2 {
    background: #F07838 !important;
    color: #fff !important;
    border: 2px solid #F07838 !important;
    padding: 13px 28px !important;
    font-size: 15px !important;
    font-weight: 700 !important;
    border-radius: 6px !important;
}
#tarteaucitronPersonalize2:hover {
    background: #D96139 !important;
    border-color: #D96139 !important;
}
#tarteaucitronAllDenied2 {
    background: #ad9989 !important;
    color: #fff !important;
    border: 2px solid #ad9989 !important;
    padding: 13px 28px !important;
    font-size: 15px !important;
    font-weight: 700 !important;
    border-radius: 6px !important;
    box-shadow: none !important;
}
#tarteaucitronAllDenied2:hover {
    background: #6B7280 !important;
    border-color: #6B7280 !important;
    color: #fff !important;
}
@media (max-width: 430px) {
    #tarteaucitronRoot #tarteaucitronAllDenied2,
    #tarteaucitronRoot #tarteaucitronPersonalize2 {
        padding: 13px 15px !important;
    }
}
@media (max-width: 395px) {
    #tarteaucitronAllDenied2,
    #tarteaucitronPersonalize2 {
        padding: 13px 12px !important;
    }
}
#tarteaucitronCloseAlert {
    background: transparent !important;
    color: #404923 !important;
    border: none !important;
    font-size: 15px !important;
    text-decoration: underline !important;
    box-shadow: none !important;
    margin-bottom: 0 !important;
    margin-top: 6px !important;
}
#tarteaucitronCloseAlert:hover {
    color: #fff !important;
    text-decoration: underline !important;
}
.tarteaucitronAllow, #tarteaucitronAllAllowed {
    background: #F07838 !important;
    border-color: #F07838 !important;
    color: #fff !important;
}
.tarteaucitronAllow:hover, #tarteaucitronAllAllowed:hover {
    background: #D96139 !important;
    border-color: #D96139 !important;
}
.tarteaucitronDeny, #tarteaucitronAllDenied {
    background: #9CA3AF !important;
    border-color: #9CA3AF !important;
    color: #fff !important;
}
.tarteaucitronDeny:hover, #tarteaucitronAllDenied:hover {
    background: #6B7280 !important;
    border-color: #6B7280 !important;
}
`;

function setupBannerPadding() {
    function sync() {
        var banner = document.getElementById('tarteaucitronAlertBig');
        if (!banner) return;
        var style = getComputedStyle(banner);
        var visible = style.display !== 'none' && parseFloat(style.opacity) > 0;
        if (visible) banner.style.display = 'flex';
        document.body.style.paddingBottom = visible ? banner.offsetHeight + 'px' : '';
    }

    new MutationObserver(sync).observe(document.body, { attributes: true, childList: true, subtree: true });
    window.addEventListener('resize', sync);
    sync();
}

export function initTarteaucitron() {
    const cfg = window.MH_TARTEAUCITRON_CONFIG;
    if (!cfg || typeof tarteaucitron === 'undefined') return;

    const lang = (cfg.lang || 'fr').replace(/^_/, '').replace(/_.*$/, '');

    const style = document.createElement('style');
    style.textContent = CONSENT_CSS;
    document.head.appendChild(style);

    var customText = {};
    if (CONSENT_MESSAGES[lang]) customText.alertBigPrivacy = CONSENT_MESSAGES[lang];
    if (DENY_LABELS[lang])     customText.denyAll          = DENY_LABELS[lang];
    if (Object.keys(customText).length) window.tarteaucitronCustomText = customText;

    setupBannerPadding();

    tarteaucitron.init({
        privacyUrl:              cfg.privacyUrl,
        orientation:             'bottom',
        showAlertSmall:          false,
        cookieslist:             false,
        highPrivacy:             true,
        AcceptAllCta:            true,
        DenyAllCta:              true,
        handleBrowserDNTRequest: true,
        mandatory:               true,
        lang:                    lang,
    });

    // Google Consent Mode v2 — GTM loads unconditionally with default denied signals.
    // This service fires gtag consent update when the user accepts.
    tarteaucitron.services.googleConsentMode = {
        key:         'googleConsentMode',
        type:        'analytic',
        name:        'Google Analytics & Ads',
        uri:         'https://policies.google.com/privacy',
        needConsent: true,
        cookies:     ['_ga', '_gid', '_gcl_au', '_gcl_aw', '_gads'],
        js: function () {
            if (typeof gtag === 'undefined') return;
            gtag('consent', 'update', {
                'analytics_storage':  'granted',
                'ad_storage':         'granted',
                'ad_user_data':       'granted',
                'ad_personalization': 'granted',
            });
        },
        fallback: function () { /* default signals stay denied — nothing to do */ },
    };
    (tarteaucitron.job = tarteaucitron.job || []).push('googleConsentMode');

    if (cfg.facebookPixelId) {
        tarteaucitron.user.facebookpixelId = cfg.facebookPixelId;

        // Idempotent: safe to call more than once (e.g. forced + real consent both
        // reaching this job). fbq presence guards the init half, the pending-events
        // array is cleared after being drained so replays are no-ops.
        tarteaucitron.services.facebookpixel.js = function () {
            if (!window.fbq && tarteaucitron.user.facebookpixelId) {
                var n = window.fbq = function () { n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments) };
                if (!window._fbq) window._fbq = n;
                n.push = n; n.loaded = !0; n.version = '2.0'; n.queue = [];
                fbq('init', tarteaucitron.user.facebookpixelId, cfg.facebookAdvancedMatching || undefined);
                fbq('track', 'PageView');
            }
            (window.MH_PENDING_FB_EVENTS || []).forEach(function (t) {
                fbq('track', t.name, t.params1, t.params2);
            });
            window.MH_PENDING_FB_EVENTS = [];
        };

        tarteaucitron.job.push('facebookpixel');

        if (cfg.fbx) tarteaucitron.services.facebookpixel.js();
    }
    if (cfg.tiktokPixelId) {
        tarteaucitron.user.tiktokpixelId = cfg.tiktokPixelId;
        tarteaucitron.job.push('tiktokpixel');
    }
    if (cfg.mixpanelToken) {
        tarteaucitron.user.mixpanel = cfg.mixpanelToken;
        tarteaucitron.job.push('mixpanel');
    }

    setupConsentTracking(cfg);
}

function setupConsentTracking(cfg) {
    function push(event, source, extra) {
        if (typeof window.dataLayer === 'undefined') return;
        window.dataLayer.push(Object.assign({
            event:          event,
            consent_country: cfg.country || null,
            consent_locale:  cfg.lang    || null,
            consent_source:  source,
        }, extra || {}));
    }

    function acceptedServices() {
        if (typeof tarteaucitron === 'undefined' || !tarteaucitron.state) return [];
        return (tarteaucitron.job || []).filter(k => tarteaucitron.state[k] === true);
    }

    document.addEventListener('click', function (e) {
        var btn = e.target.closest
            ? e.target.closest('#tarteaucitronPersonalize2, #tarteaucitronAllDenied2, #tarteaucitronClosePanel, #tarteaucitronClosePanelCookie')
            : null;
        if (!btn) return;

        if (btn.id === 'tarteaucitronPersonalize2') {
            push('consent_granted', 'banner');
        } else if (btn.id === 'tarteaucitronAllDenied2') {
            push('consent_denied', 'banner');
        } else if (btn.id === 'tarteaucitronClosePanel' || btn.id === 'tarteaucitronClosePanelCookie') {
            var accepted = acceptedServices();
            var total    = (tarteaucitron.job || []).length;
            if (accepted.length === total && total > 0) {
                push('consent_granted', 'panel');
            } else if (accepted.length === 0) {
                push('consent_denied', 'panel');
            } else {
                push('consent_customized', 'panel', { consent_services_accepted: accepted });
            }
        }
    });
}
